export default __webpack_public_path__ + "static/hero-bg1-82fc7416624f7e54a222475671a5e21d.webp";